import { Link } from "react-router-dom";
import TableActionMenu from "../../../components/table-action-menu/table-action-menu";

const CompanyColumns = (navigate) => {
  return [
  {
    dataKey: "companyID",
    name: "ID",
    width: "80px",
    minWidth: "80px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "companyName",
    name: "Company Name",
    width: "300px",
    minWidth: "300px",
    align: "left",
    sortable: true,
    render: (value, rowData) => {
      return (
        <Link
          style={{ color: "inherit" }}
          to={`/companiesview/${rowData.companyID}/details`}
        >
          {value}
        </Link>
      );
    },
  },
  {
    dataKey: "type",
    name: "Type",
    width: "100px",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "dateCreated",
    name: "Created (mm/dd/yyyy)",
    width: "100px",
    minWidth: "150px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "companyState",
    name: "State",
    width: "100px",
    minWidth: "100px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "webAddress",
    name: "Web Address",
    width: "300px",
    minWidth: "300px",
    align: "left",
    // sortable: true,
  },
  {
    dataKey: "phoneNumber",
    name: "Phone",
    width: "150px",
    minWidth: "150px",
    align: "left",
    // sortable: true,
  },
  {
    dataKey: "primaryContactName",
    name: "Primary Contact",
    width: "200px",
    minWidth: "300px",
    align: "left",
    render: (value, rowData) =>
      value ? (
        <Link
          to={`/contactsview/${rowData.primaryContactId}/details`}
          style={{
            textDecoration: "underline",
            color: "inherit",
          }}
        >
          {value}
        </Link>
      ) : (
        ""
      ),
  },
  {
    dataKey: "primaryContactEmail",
    name: "Primary Contact Email",
    width: "300px",
    minWidth: "300px",
    align: "left",
    render: (value) => (value ? value : ""),
  },
  {
    dataKey: "primaryContactPhone",
    name: "Primary Contact Phone",
    width: "150px",
    minWidth: "150px",
    align: "left",
    render: (value) => (value ? value : ""),
  },
  {
    name: "",
    dataKey: "actions",
    width: "10px",
    minWidth: "10px",
    align: "center",
    render: (cellData, rowData) => {
      return (
        <TableActionMenu
        options={[
          {
            title: `View Company Page`,
            onClick: () => {
              navigate(`/companiesview/${rowData.companyID}/details`);
            },
          },
          {
            title: (
              <span style={{ display: "block", whiteSpace: "normal", textAlign: "center" }}>
                View Primary <br /> Contact Page
              </span>
            ),
            onClick: () => {
              if (rowData.primaryContactId) {
                navigate(`/contactsview/${rowData.primaryContactId}/details`);
              } else {
                alert("No primary contact found for this company.");
              }
            },
          },      
        ]}
        noBorder
      />
      );
    },
  },
]};

export default CompanyColumns;
